import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

const ReleaseNotesList = lazy(() => import('./components/List'))
const ReleaseNotesEditor = lazy(() => import('./components/Editor'))

// Route configuration
const ReleaseNotesModule: RouteObject = {
    path: 'release-notes',
    children: [
        {
            index: true,
            element: <ReleaseNotesList />,
        },
        {
            path: 'create',
            element: <ReleaseNotesEditor />,
        },
    ],
}

export default ReleaseNotesModule
